import './NotificationIcon.scss';

import React, { useMemo } from 'react';
import { NotificationData } from '../notifications-types';
import { NotificationStatus } from '../data';
import { InvalidIcon, GoFormzSystemUserIcon } from '../../icons/icons';
import UserIcon from '../../components/UserIcon';

export type NotificationIconProps = {
  notificationData: NotificationData;
};

export default function NotificationIcon({ notificationData }: NotificationIconProps) {
  const icon = useMemo(() => {
    if (notificationData.status === NotificationStatus.Error) {
      return <InvalidIcon />;
    }

    if (notificationData.eventUserInfo?.initiatedBySystemUser) {
      return <GoFormzSystemUserIcon />;
    }

    if (notificationData.eventUserInfo) {
      const { initiatorUsername, initiatorFirstName, initiatorLastName, initiatorId, initiatorHasProfilePicture } = notificationData.eventUserInfo;
      return (
        <UserIcon
          emailAddress={initiatorUsername}
          firstName={initiatorFirstName}
          lastName={initiatorLastName}
          userId={initiatorId}
          hasProfilePicture={initiatorHasProfilePicture}
        />
      );
    }
  }, [notificationData.status, notificationData.eventUserInfo]);

  return <div className="notification-icon">{icon}</div>;
}
